import React, { useEffect, useState } from "react";
import { Box, Button, Menu, MenuButton, MenuItem, MenuList, Text, VStack } from '@chakra-ui/react';
import { ChevronDownIcon } from "@chakra-ui/icons";
import { v4 as uuidv4 } from 'uuid';
import { useContentManagement } from "./ContentManagementProvider";
import { FaPlus } from "react-icons/fa";
import { usePopper } from "react-popper";
export const ContentArea = (props) => {
    var _a;
    const { contentElementDefinitions, isEditing } = useContentManagement();
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes, forceUpdate } = usePopper(props.attachControlsTo, popperElement, { placement: "bottom" });
    const add = (type) => {
        const newStack = {
            id: uuidv4(),
            type: type,
            data: null
        };
        props.onChange([...props.contentElements, newStack]);
    };
    const move = (direction, index, array) => {
        if (direction === -1 && index === 0) {
            return array;
        }
        if (direction === 1 && index === array.length - 1) {
            return array;
        }
        const mutable = [...array];
        const mover = mutable.splice(index, 1)[0];
        // Take the current element out via splice and insert it at one index earlier also using splice
        mutable.splice(index + direction, 0, mover);
        return mutable;
    };
    useEffect(() => {
        setTimeout(() => {
            if (forceUpdate) {
                forceUpdate();
            }
        }, 50);
    }, [props.contentElements, forceUpdate]);
    return (React.createElement(React.Fragment, null,
        props.contentElements.map((contentElement, i) => {
            const definition = contentElementDefinitions.find(item => item.type === contentElement.type);
            if (!definition) {
                return null;
            }
            return React.createElement(definition.render, { key: contentElement.id, contentElement: contentElement, onChange: (changed) => props.onChange([...props.contentElements].map(item => item.id === changed.id ? changed : item)), onDelete: () => props.onChange(props.contentElements.filter(item => item.id !== contentElement.id)), onUp: () => {
                    props.onChange(move(-1, i, props.contentElements));
                }, onDown: () => {
                    props.onChange(move(1, i, props.contentElements));
                } });
        }),
        props.contentElements.length === 0 && isEditing &&
            React.createElement(VStack, { w: "100%", bg: "gray.50", borderColor: "gray.100", borderRadius: "md", borderWidth: 1, p: 6, alignItems: "center" },
                React.createElement(Text, null, "Empty Content Area"),
                React.createElement(Text, { fontSize: "xs", color: "gray.700" }, "Start by adding new content elements below.")),
        props.showAdd && isEditing && React.createElement(Box, Object.assign({ ref: setPopperElement, zIndex: 10, style: Object.assign({ position: "absolute", left: 0 }, styles.popper) }, attributes.popper, { bg: "white", p: 2, boxShadow: "md", borderRadius: "md" }), props.allowedTypes.length > 1 ?
            React.createElement(Menu, null,
                React.createElement(MenuButton, { as: Button, rightIcon: React.createElement(ChevronDownIcon, null) }, "Add new"),
                React.createElement(MenuList, null, contentElementDefinitions.filter(item => props.allowedTypes.includes(item.type)).map(definition => (React.createElement(MenuItem, { key: definition.type, icon: definition.icon, onClick: () => {
                        add(definition.type);
                    } }, definition.label)))))
            :
                React.createElement(Button, { leftIcon: React.createElement(FaPlus, null), onClick: () => {
                        add(props.allowedTypes[0]);
                    } },
                    "Add ", (_a = contentElementDefinitions.find(definition => definition.type === props.allowedTypes[0])) === null || _a === void 0 ? void 0 :
                    _a.label))));
};
